import React from 'react';
import { useTranslation } from 'react-i18next';
import DeviationSelector from '..';
import LoadingIndicator from '@wix/da-ds/pkg/LoadingIndicator';
import SelectedItemsPanel from '../../../_partials/SelectedItemsPanel';
import PopupInnerLayout from '../../../_partials/PopupInnerLayout';
import Flex from '@wix/da-ds/pkg/Flex';
import { useCurrentTierDeviations } from '../../../_hocs/withCurrentTierDeviations';

export type Props = {};

const TierDeviationSelector: React.FC<Props> = () => {
  const {
    isInitialized,
    isFetching,
    fetchMoreTierDeviations,
    hasMore,
    deviations,
  } = useCurrentTierDeviations();
  const { t } = useTranslation();

  const renderEmpty = () => {
    return (
      <Flex
        fullWidth
        fullHeight
        direction="column"
        justifyContent="center"
        alignItems="center"
      >
        {t!('mediapopup.empty.tier')}
      </Flex>
    );
  };

  const renderContent = () => {
    return (
      <>
        {isInitialized &&
          (!deviations.length && !isFetching && !hasMore ? (
            renderEmpty()
          ) : (
            <DeviationSelector deviations={deviations} />
          ))}
        {(!isInitialized || isFetching) && (
          <LoadingIndicator
            view="daSymbol"
            coverMode={!hasMore && !isFetching}
          />
        )}
      </>
    );
  };

  const fetchMoreTierDeviationsIfNeeded = () => {
    if (!hasMore || isFetching) {
      return;
    }
    fetchMoreTierDeviations();
  };

  return (
    <PopupInnerLayout
      headerExtrasBottomZone={<SelectedItemsPanel />}
      scrollableContent={renderContent()}
      onScrolledToBottom={fetchMoreTierDeviationsIfNeeded}
      onNotScrollable={fetchMoreTierDeviationsIfNeeded}
    />
  );
};
TierDeviationSelector.displayName = 'TierDeviationSelector';

export default TierDeviationSelector;
